import { clsx } from 'clsx'
import { IResult, UAParser } from 'ua-parser-js'

function parseUserAgent(userAgent?: string): IResult {
  const parser = new UAParser(userAgent)

  return parser.getResult()
}

export function getDeviceDescription(userAgent?: string, isMonochrome = false): React.JSX.Element {
  if (!userAgent) return <>-</>

  const { browser, device, os } = parseUserAgent(userAgent)

  return (
    <>
      {device.type === 'mobile' ? `${device.vendor} ${device.model}` : `${os.name}`}{' '}
      <span className="relative text-lg !leading-none">•</span>{' '}
      <span className={clsx(!isMonochrome && 'text-gray-90')}>
        {browser.name} {browser.major}
      </span>
    </>
  )
}
